import { render } from "./EditMasterBoardModal.vue?vue&type=template&id=35161808&scoped=true"
import script from "./EditMasterBoardModal.vue?vue&type=script&lang=js"
export * from "./EditMasterBoardModal.vue?vue&type=script&lang=js"

import "./EditMasterBoardModal.vue?vue&type=style&index=0&id=35161808&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-35161808"

export default script